//--------------------------------------------------------------------------------------------------
//# Imports

import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import { useAccountOperator } from "../../scripts/AccountOperator";

import './adminlogin.css'

import admin_login_banner from '../../image/cardImage.png'












//--------------------------------------------------------------------------------------------------
//# Variables

let alchmizer_image = admin_login_banner;
const delay_gap = 200;
let mobile = window.innerWidth <= 600;

//AppStart
const AdminLogin = () => {
  const { ready, authenticated, login, logout, user } = useAccountOperator();
  const navigate = useNavigate();









  
//--------------------------------------------------------------------------------------------------
//# Functions

  function mouseOver(event) {
    let element = document.getElementById(event.target.id);
    element.style.transform = 'scale(1.20)';
  }

  function mouseLeave(event) {
    let element = document.getElementById(event.target.id);
    element.style.transform = 'scale(1.0)';
  }

  useEffect(() => {
    Aos.init({ duration: 2000 });
    
    // Reset AOS attributes after animation finishes
    setTimeout(() => {
      const buttons = document.querySelectorAll('.adminLoginPrivyButton');
      buttons.forEach(button => {
        button.addEventListener('mouseenter', () => {
          button.style.transform = 'scale(1.15)';
          button.style.transition = 'transform 0.5s ease-in-out';
        });
  
        button.addEventListener('mousedown', () => {
          button.style.transform = 'scale(1.2)';
          button.style.transition = 'transform 0.05s ease-in-out';
        });
    
        button.addEventListener('mouseleave', () => {
          button.style.transform = 'scale(1.0)';
          button.style.transition = 'transform 0.5s ease-in-out';
        });
      });
    }, 1000);  // Match to AOS duration
  }, []);

  // TOGGLE: Enable to make redirect to Admin Console automatic on page load (if logged in as admin)
  //
  // useEffect(() => {
  //   if (authenticated) {
  //     navigate("/admin/console");
  //   }
  // }, [authenticated, navigate]);







//--------------------------------------------------------------------------------------------------
//# HTML

  if (!ready) return <p>Loading…</p>;

  return (
    <div className='adminLogin' id='anchorElement_adminLogin'>
      <div className='adminLoginContainer'>
        <div className='adminLoginTextContainer'>
          <div className='adminLoginImageContainer'>
            <img src={alchmizer_image} alt='' className='adminLoginImage' id='adminLoginImage'
              data-aos="flip-right" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_adminLogin"/>
            </div>
          <div className='adminLoginTitleText'
              data-aos="zoom-in" data-aos-delay={1 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_adminLogin">
              <span style={{ color: 'var(--color-main)' }}>Admin Login</span>
          </div>
          <div className='adminLoginPrivyContainer'>
            {!authenticated ? (
              <button className='adminLoginPrivyButton' id='adminLoginPrivyLoginButton' onClick={login} onMouseOver={mouseOver} onMouseLeave={mouseLeave}>
                Privy Log in / Sign up
              </button>
            ) : (
              <div>
                <button className='adminLoginPrivyButton' id='adminLoginConsoleButton' onClick={() => navigate("/admin/console")} onMouseOver={mouseOver} onMouseLeave={mouseLeave}>
                  Admin Console
                </button>
                <button className='adminLoginPrivyButton' id='adminLoginPrivyLogoutButton' onClick={logout} onMouseOver={mouseOver} onMouseLeave={mouseLeave}>
                  Log out
                </button>
                {/* <p>You are logged in as:</p>
                <pre>
                  {JSON.stringify(user, null, 2)}
                </pre> */}
              </div>
            )}
          </div>
        {/* <br></br>
        <div className='adminLoginText'
          data-aos="fade-right" data-aos-delay={2 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_adminLogin">
            <span style={{ color: 'var(--color-main)' }}>
              The Astrologizer</span> - derives a complete astrological profile from birth information.</div>
        <div className='adminLoginText'
          data-aos="fade-left" data-aos-delay={3 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_adminLogin">
            <span style={{ color: 'var(--color-main)' }}>
              The Alchemizer</span> - derives alchemical nature and properties from astrological profile.</div>
        <div className='adminLoginText'
          data-aos="fade-right" data-aos-delay={4 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_adminLogin">
            <span style={{ color: 'var(--color-main)' }}>
              The Imaginizer</span> - generates personalized art, charts, and insights using the derived astrological & alchemical information.</div>
        <br></br> */}
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;